import React from 'react';
import { motion } from 'framer-motion';
export function Contact() {
  return <section id="contact" className="py-32 md:py-48 border-t border-border" data-id="element-124">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="glass-card p-12 md:p-16 rounded-3xl text-center" data-id="element-126">
          <h2 className="text-3xl md:text-5xl font-bold text-primary tracking-tight mb-6" data-id="element-127">
            Building the next generation of enterprise AI products?
          </h2>

          <p className="text-lg md:text-xl text-secondary leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-128">
            I am exploring director and head-of-product opportunities where I
            can build the platforms, teams, and governance systems that make AI
            work at enterprise scale.
          </p>

          <div className="mb-12" data-id="element-129">
            <a href="mailto:karan.dhir@outlook.com" className="inline-block text-xl md:text-2xl font-medium text-gold hover:text-gold-hover transition-colors" data-id="element-130">
              karan.dhir@outlook.com
            </a>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-131">
            <a href="https://www.linkedin.com/in/dhirkaran/" target="_blank" rel="noopener noreferrer" className="text-secondary hover:text-primary transition-colors font-medium" data-id="element-132">
              LinkedIn
            </a>
            <span className="hidden sm:block text-border" data-id="element-133">•</span>
            <a href="https://substack.com/@karandhir" target="_blank" rel="noopener noreferrer" className="text-secondary hover:text-primary transition-colors font-medium" data-id="element-134">
              Substack
            </a>
            <span className="hidden sm:block text-border" data-id="element-135">•</span>
            <a href="https://github.com/kd-511" target="_blank" rel="noopener noreferrer" className="text-secondary hover:text-primary transition-colors font-medium" data-id="element-136">
              GitHub
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}